// Gastrointestinal subsection form field enum
export enum GastrointestinalFormField {
  GASTROINTESTINAL_GI_ASSESSMENT = 'medical-background/gastrointestinal/gi-assessment',
  GASTROINTESTINAL_BM_DATE = 'medical-background/gastrointestinal/bm-date',
  GASTROINTESTINAL_GU_ASSESSMENT = 'medical-background/gastrointestinal/gu-assessment',
  GASTROINTESTINAL_CATHETER = 'medical-background/gastrointestinal/catheter',
  GASTROINTESTINAL_CATHETER_TYPE = 'medical-background/gastrointestinal/catheter-type',
  GASTROINTESTINAL_FEEDING_TUBE = 'medical-background/gastrointestinal/feeding-tube',
  GASTROINTESTINAL_FEEDING_TUBE_AMOUNT = 'medical-background/gastrointestinal/feeding-tube-amount',
  GASTROINTESTINAL_FEEDING_TUBE_DURATION = 'medical-background/gastrointestinal/feeding-tube-duration',
  GASTROINTESTINAL_FEEDING_TUBE_TYPE = 'medical-background/gastrointestinal/feeding-tube-type',
  GASTROINTESTINAL_FEEDING_TUBE_SIZE = 'medical-background/gastrointestinal/feeding-tube-size',
  GASTROINTESTINAL_FEEDING_TOTAL_NUMBER = 'medical-background/gastrointestinal/feeding-total-number',
  GASTROINTESTINAL_FEEDING_TUBE_SITE = 'medical-background/gastrointestinal/feeding-tube-site',
  GASTROINTESTINAL_FEEDING_TUBE_NOTES = 'medical-background/gastrointestinal/feeding-tube-notes',
  GASTROINTESTINAL_NUTRITION_WNL = 'medical-background/gastrointestinal/nutrition-wnl',
  GASTROINTESTINAL_NUTRITIONAL_FACTORS = 'medical-background/gastrointestinal/nutritional-factors',
  GASTROINTESTINAL_DIET_REQUIREMENTS = 'medical-background/gastrointestinal/diet-requirements',
  GASTROINTESTINAL_NUTRITION_NOTES = 'medical-background/gastrointestinal/nutrition-notes',
  GASTROINTESTINAL_NUTRITIONAL_SCREENING = 'medical-background/gastrointestinal/nutritional-screening',
  GASTROINTESTINAL_HISTORY_NOTES = 'medical-background/gastrointestinal/gastrointestinal-history-notes',
  GASTROINTESTINAL_SYSTEM_SUMMARY = 'medical-background/gastrointestinal/system-summary'
}
